module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "p3"
  }, [_c('nav', {
    staticClass: "flex flex-wrap dark-grey justify-between"
  }, [_c('ul', {
    staticClass: "m0 list-reset"
  }, [_c('li', {
    staticClass: "inline-block mr3"
  }, [_vm._v("© 2017—" + _vm._s(_vm.year) + " "), _c('a', {
    attrs: {
      "href": "http://bahna.land",
      "title": "Сделано в Багне"
    }
  }, [_vm._v("Bahna")]), _vm._v("+"), _c('a', {
    attrs: {
      "href": "http://www.ptushki.org/",
      "title": "Сделано в АПБ"
    }
  }, [_vm._v("АПБ")])]), _vm._v(" "), _vm._l((_vm.content.main), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "inline-block mr2"
    }, [_c('a', {
      attrs: {
        "href": item.link
      },
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "m0 list-reset"
  }, _vm._l((_vm.content.social), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "inline-block mr2"
    }, [_c('a', {
      attrs: {
        "href": item.link
      },
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7307d054","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 127
// module chunks = 0